import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation"; // Rename to your file name for custom animation

const splashScreen = {
  enabled: true, // set false to disable splash screen
  animation: splashAnimation,
  duration: 2000 // Set animation duration as per your animation
};

const illustration = {
  animated: true // Set to false to use static SVG
};

const greeting = {
  username: " Salman Ali ",
  title: "Hi all, I'm Salman",
  subTitle: emoji(
    "I'm a Frontend developer.Currently studying Web'n mobile hybrid application development course from SMIT.I am enthusiastic learner who is constantly eager to experiment with new technologies and work in various feilds."
  ),
  resumeLink:
    "", // Set to empty to hide the button
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/SalmanAli09",
  linkedin: "https://www.linkedin.com/in/salman-ali-37279b22a/",
  gmail: "msalmanali7890@gmail.com",
  facebook: "https://www.facebook.com/msalman.imran?mibextid=ZbWKwL",
  display: true
};

// Skills Section

const skillsSection = {
  title: "What I do",
  subTitle: "CRAZY FRONTEND DEVELOPER WHO WANTS TO EXPLORE EVERY TECH STACK",
  skills: [
    emoji(
      "⚡ Develop highly interactive Front end / User Interfaces for your web and mobile applications"
    ),
    emoji("⚡ Progressive Web Applications ( PWA )."),
    emoji(
      "⚡ Integration of third party Libraries"
    )
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {
      skillName: "html-5",
      fontAwesomeClassname: "fab fa-html5"
    },
    {
      skillName: "css3",
      fontAwesomeClassname: "fab fa-css3-alt"
    },
    {
      skillName: "Bootstrap",
      fontAwesomeClassname: "fa-brands fa-mdb"
    },
    {
      skillName: "JavaScript",
      fontAwesomeClassname: "fab fa-js"
    },
    {
      skillName: "reactjs",
      fontAwesomeClassname: "fab fa-react"
    },
    {
      skillName: "npm",
      fontAwesomeClassname: "fab fa-npm"
    },
    {
      skillName: "firebase",
      fontAwesomeClassname: "fas fa-fire"
    },

  ],
  display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "Nasra School Malir Karachi",
      logo: require("./assets/images/nasra.png"),
      subHeader: "Matriculation",
      duration: "April 2017 - September 2018",
    },
    {
      schoolName: "Govt. Degree Science And Commerce College Malir",
      logo: require("./assets/images/college.png"),
      subHeader: "Pre-engineering",
      duration: "July 2019 - December 2021"
    },
    {
      schoolName: "Saylani Mass IT Training Programme",
      logo: require("./assets/images/smit.png"),
      subHeader: "Web & Mobile Hybrid Application Development Course",
      duration: "Feburary 2022 - Present"
    }
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Frontend/Design", //Insert stack or technology you have experience in
      progressPercentage: "90%" //Insert relative proficiency in percentage
    },
    {
      Stack: "DataBase",
      progressPercentage: "70%"
    },
    {
      Stack: "Programming",
      progressPercentage: "50%"
    }
  ],
  displayCodersrank: false // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "Frontend Developer Intern",
      company: "SMIT",
      companylogo: require("./assets/images/smitwhit.png"),
      date: "May – October",
      descBullets: [
        "Converted PSD Mockups into HTML , Javascript & JSON",
        "Developing Social Applications Like Chat Web Application & Blog Website with Database"
      ]
    }
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
  display: true // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Big Projects",
  subtitle: "SOME STARTUPS AND COMPANIES THAT I HELPED TO CREATE THEIR TECH",
  projects: [
    {
      image: require("./assets/images/Turo.png"),
      projectName: "turo.com Clone ",
      projectDesc: "Find your drive Explore the world's largest car sharing marketplace",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://turo-clone-web.netlify.app/"
        }
        //  you can add extra buttons here.
      ]
    },
    {
      image: require("./assets/images/quiz.jpg"),
      projectName: "Quiz.",
      projectDesc: "Quiz App developed using javascript and localstorage",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://quiz-app-cyan-beta.vercel.app/"
        }
      ]
    },
    {
      image: require("./assets/images/game.jpg"),
      projectName: "Tic Tac Toe Game",
      projectDesc: "TicTacToe Game Developed Using Pure JavaScript",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://tictactoegame-clone.netlify.app/"
        }
      ]
    },
    {
      image: require("./assets/images/form.jpg"),
      projectName: "Register Me!",
      projectDesc: "Registration Form Using Javascript Along With Admin Panel",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://form-localstorage.vercel.app/"
        }
      ]
    },
  ],
  display: true // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Achievements And Certifications 🏆 "),
  subtitle:
    "Achievements, Certifications, Award Letters and Some Cool Stuff that I have done !",

  achievementsCards: [
    {
      title: "Responsive Website Design",
      subtitle:
        "Developed Responsive Website Designs.",
      image: require("./assets/images/fcc.jfif"),
      imageAlt: "Google Assistant Action Logo",
      footerLink: [
        {
          name: "View Certification",
          url: "https://www.freecodecamp.org/certification/Muhammad_Salman_Ali/responsive-web-design"
        }
      ]
    },

    {
      title: "Linux Professional Academy",
      subtitle: "Completed Certifcation from SMIT for PWA Web App Development",
      image: require("./assets/images/linux.jfif"),
      imageAlt: "lpi Logo",
      footerLink: [
        { name: "View Certification", url: "https://sg.docs.wps.com/l/sADAKDzHYlKeKAevGioiupxQ" }
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "Blogs",
  subtitle:
    "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",
  displayMediumBlogs: "true", // Set true to display fetched medium blogs instead of hardcoded ones
  blogs: [
    {
      url: "https://blog.usejournal.com/create-a-google-assistant-action-and-win-a-google-t-shirt-and-cloud-credits-4a8d86d76eae",
      title: "Win a Google Assistant Tshirt and $200 in Google Cloud Credits",
      description:
        "Do you want to win $200 and Google Assistant Tshirt by creating a Google Assistant Action in less then 30 min?"
    },
    {
      url: "https://medium.com/@saadpasta/why-react-is-the-best-5a97563f423e",
      title: "Why REACT is The Best?",
      description:
        "React is a JavaScript library for building User Interface. It is maintained by Facebook and a community of individual developers and companies."
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: emoji(
    "I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"
  ),

  talks: [
    {
      title: "Build Actions For Google Assistant",
      subtitle: "Codelab at GDG DevFest Karachi 2019",
      slides_url: "https://bit.ly/saadpasta-slides",
      event_url: "https://www.facebook.com/events/2339906106275053/"
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    "https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo"
  ],
  display: false // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle:
    "Discuss a project or just want to say hi? My Inbox is open for all.",
  number: "+92-3099876366",
  email_address: "msalmanali7890@gmail.com"
};

// Twitter Section

const twitterDetails = {
  userName: "twitter", //Replace "twitter" with your twitter username without @
  display: false // Set true to display this section, defaults to false
};

const isHireable = false; // Set false if you are not looking for a job. Also isHireable will be display as Open for opportunities: Yes/No in the GitHub footer

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails,
  isHireable
};
